module.exports = __webpack_public_path__ + "static/media/upload.5b50e6b5.svg";